import { ColType, FilterConditions } from '@/lib/utils.type'
import { createSlice } from '@reduxjs/toolkit'
import { CaseField } from '@/services/types/api.types'

export type CaseManagementState2 = {
  isNavigated: {
    flag: boolean
    type: string
  }
  filterPayload: {
    fields: CaseField[]
    conditions: FilterConditions
  }
  caseDetails: {
    Id: string
    canAddComments?: boolean
  }
  isLoading: boolean
  accessorKey: string
  caseManagemntTableData: Record<string, string | null>[]
  activefilterConditions: { field: string; value: string[] }[]
  activeTableHeaders: ColType[]
  defaultTableHeaders: ColType[]
  dropdownValue: string
}

const initialState: CaseManagementState2 = {
  isNavigated: { flag: false, type: '' },
  filterPayload: { fields: [], conditions: [] },
  caseDetails: { Id: '' },
  isLoading: true,
  accessorKey: 'IsClosed',
  caseManagemntTableData: [],
  defaultTableHeaders: [
    { name: 'CaseNumber', label: 'Case Number' },
    { name: 'Priority', label: 'Priority' },
    { name: 'Acc_Name_Text__c', label: 'Account Name' },
    { name: 'Subject', label: 'Subject' },
    { name: 'Status', label: 'Status' },
    { name: 'Service_Location__c', label: 'Service Location' },
    { name: 'LastModifiedDate', label: 'Last Modified Date' },
    { name: 'CreatedDate', label: 'Created Date' },
  ],
  activeTableHeaders: [],
  activefilterConditions: [],
  dropdownValue: '',
}

const caseManagementSlice = createSlice({
  name: 'caseManagement',
  initialState,
  reducers: {
    setActiveTableHeaders: (state, action) => {
      state.activeTableHeaders = action.payload
    },

    setCaseManagemntTableData: (state, action) => {
      state.caseManagemntTableData = action.payload
    },

    isLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setIsNavigated: (state, action) => {
      state.isNavigated = action.payload
    },

    setFilterPayload: (state, action) => {
      state.filterPayload = action.payload
    },

    setCaseDetails: (state, action) => {
      state.caseDetails = action.payload
    },

    setDefaultTableHeaders: (state, action) => {
      state.defaultTableHeaders = action.payload
    },
    setActiveFilterConditions: (state, action) => {
      state.activefilterConditions = action.payload
    },
    setDropdownValue: (state, action) => {
      state.dropdownValue = action.payload
    },
  },
})

export const {
  setActiveTableHeaders,
  setCaseManagemntTableData,
  setIsNavigated,
  setFilterPayload,
  isLoading,
  setCaseDetails,
  setDefaultTableHeaders,
  setActiveFilterConditions,
  setDropdownValue,
} = caseManagementSlice.actions

export default caseManagementSlice.reducer
